import {
  CarrierKind,
  ParamsRedirectToHold,
  ResponseRedirectToHoldSubmit,
  ResponseRedirectToHoldSubmitV,
  RequestRedirectToHoldSubmit,
} from '../../../server/api/schema';

import { decode } from '../../../server/lib/codec';

export interface SubmitParams {
  carrier: CarrierKind;
  trackingNumber: ParamsRedirectToHold['trackingNumber'];
  request: RequestRedirectToHoldSubmit;
}

const submitHold = async ({
  carrier,
  trackingNumber,
  request,
}: SubmitParams): Promise<ResponseRedirectToHoldSubmit> => {
  const url = `/api/v1/delivery-management/${carrier}/redirect-to-hold/${trackingNumber}/submit`;

  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(request),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return decode(ResponseRedirectToHoldSubmitV, await response.json());
};

export default submitHold;
